import * as React from 'react';

import { connectToDescriptors, IDescriptorProps } from '../сonnectToDescriptors';
import { priceInputDescriptors, priceTypeDescriptors } from '../../constants/descriptors';
import { TTypedThunkDispatch } from '../../types/thunk';
import { getOffersCount } from '../../actions/offersData';
import { updateTags } from '../../actions/filterTags';
import { getPrice } from './utils';
import { FilterTooltip } from '../../components/FilterTooltip';
import { isDescriptorActive } from '../../utils/filters';
import { getPriceButtonText } from '../../utils/priceText';
import { QuickPriceFilter } from './QuickPriceFilter';

export interface IPriceInputProps extends IDescriptorProps<number> {
  getOffersCount(): void;
  updateTags(): void;
}

export const PriceInputsComponent = (props: IPriceInputProps) => {
  const { jsonQuery } = props;
  const { gte, lte } = getPrice(jsonQuery);

  const isPricePerMeter = React.useMemo(() => {
    const activeDescriptor = priceTypeDescriptors.find(descriptor => isDescriptorActive(descriptor)(jsonQuery));

    return activeDescriptor?.state === 'price_sm_part';
  }, [jsonQuery]);

  const buttonText = React.useMemo(() => getPriceButtonText(gte, lte, isPricePerMeter), [gte, lte, isPricePerMeter]);

  const prevPrice = React.useRef({ gte, lte });

  React.useEffect(() => {
    prevPrice.current = { gte, lte };
  });

  return (
    <FilterTooltip buttonText={buttonText} maxWidth={186} dataTestId="PriceQuickFilter">
      <QuickPriceFilter />
    </FilterTooltip>
  );
};

function mapDispatchToProps(dispatch: TTypedThunkDispatch) {
  return {
    getOffersCount: () => {
      dispatch(getOffersCount());
    },
    updateTags: () => {
      dispatch(updateTags());
    },
  };
}

export const PriceInput = connectToDescriptors(priceInputDescriptors, mapDispatchToProps)(PriceInputsComponent);
